import React, { useCallback } from "react"

import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

import type {
  TraceSpanAttributeFilterConfig,
  TraceSpanAttributeOperator,
} from "@/types/metrics/metadata"

import { TRACE_SPAN_ATTRIBUTE_OPERATORS } from "../types"

interface SpanAttributeFilterEditorProps {
  filter: TraceSpanAttributeFilterConfig
  onChange: (filter: TraceSpanAttributeFilterConfig) => void
}

export const SpanAttributeFilterEditor: React.FC<
  SpanAttributeFilterEditorProps
> = ({ filter, onChange }) => {
  const handleKeyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...filter, key: event.target.value })
  }

  const handleOperatorChange = useCallback(
    (operator: string) => {
      onChange({
        ...filter,
        operator: operator as TraceSpanAttributeOperator,
      })
    },
    [filter, onChange],
  )

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...filter, value: event.target.value })
  }

  return (
    <div className="flex items-center gap-2">
      <Input
        type="text"
        value={filter.key}
        onChange={handleKeyChange}
        placeholder="gen_ai.system"
        aria-label="Span attribute key"
        className="flex-1"
      />

      <Select value={filter.operator} onValueChange={handleOperatorChange}>
        <SelectTrigger className="w-24" aria-label="Span attribute operator">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {TRACE_SPAN_ATTRIBUTE_OPERATORS.map((operator) => (
            <SelectItem key={operator.value} value={operator.value}>
              {operator.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Input
        type="text"
        value={filter.value}
        onChange={handleValueChange}
        placeholder="openai"
        aria-label="Span attribute value"
        className="flex-1"
      />
    </div>
  )
}
